module.exports = __webpack_public_path__ + "static/logo-max-milhas-9540948e84b3f81c9611e64e01abbe78.svg";